import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/boost-ebay-sells-with-seo-tips';

export default function Example() {
  return (
    <>
      <Head>
        <title>Boost Your eBay Sales With These Easy SEO Tips</title>
        <meta
          name='description'
          content='With billions of transactions every day, selling on eBay has become highly competitive, and listing and putting up photos of your products is not enough. Having an effective marketing strategy is crucial, and this includes how you write product titles and descriptions and how you categorize each one.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/boost-ebay-sells-with-seo-tips' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/boost-ebay-sells-with-seo-tips' />
        <meta property='og:title' content='Boost Your eBay Sales With These Easy SEO Tips' />
        <meta
          property='og:description'
          content='With billions of transactions every day, selling on eBay has become highly competitive, and listing and putting up photos of your products is not enough. Having an effective marketing strategy is crucial, and this includes how you write product titles and descriptions and how you categorize each one.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
